<template>
  <div class="container">
    <div class="container-2">
      <div class="box">
        <div class="container-2-top">
          <div class="logo" @click="clickLogo">
            <img src="https://bric-jgw.oss-cn-hangzhou.aliyuncs.com/img/front/common/16988.png " alt="">
          </div>
          <div class="search">
            <input type="text" v-model="search" placeholder="请输入您想搜索的产品">
            <div class="button" @click="searchGoods">搜索</div>
          </div>
        </div>
        <div class="container-2-bottom">
<!--          <div class="right-nav" @mouseenter="hoverNavAction('enter')" @mouseleave="hoverNavAction('leave')">-->
<!--            <img src="/static/img/header/header_nav1.png" alt="">-->
<!--            <div class="right-nav-text">所有商品分类</div>-->
<!--          </div>-->
          <div class="nav-hover" v-show="navHoverShow"  @mouseleave="isShowRight = false">
            <div class="hover-left">
              <div class="quickSearchGoods">
                <img src="/static/img/header/header_nav2.png" alt="">
                <div class="text">快速找货</div>
              </div>
              <div class="goodsCategory" @mouseenter="showLeft('level2')">
                <div class="navTitle">
                  <img src="https://bric-jgw.oss-cn-hangzhou.aliyuncs.com/img/front/homepage/cplb.png" class="icon" alt="">
                  <div class="text">产品类别</div>
                  <img src="https://bric-jgw.oss-cn-hangzhou.aliyuncs.com/img/front/homepage/icon_jt_w.png" class="more" alt="">
                </div>
                <div class="navContent">
                  <div
                    class="item"
                    v-for="item in partCategoryList.level2"
                    :key="item.id"
                    @click="goToNav(item.id, item.categoryName)"
                  >{{item.categoryName}}
                  </div>
                </div>
              </div>
              <div class="categoryClass" @mouseenter="showLeft('level3')">
                <div class="navTitle">
                  <img src="https://bric-jgw.oss-cn-hangzhou.aliyuncs.com/img/front/homepage/pp.png" class="icon" alt="">
                  <div class="text">类目分类</div>
                  <img src="https://bric-jgw.oss-cn-hangzhou.aliyuncs.com/img/front/homepage/icon_jt_w.png" class="more" alt="">
                </div>
                <div class="navContent">
                  <div
                    class="item"
                    v-for="item in partCategoryList.level3"
                    :key="item.id"
                    @click="goToNav(item.id, item.categoryName)"
                  >{{item.categoryName}}</div>
                </div>
              </div>
            </div>
            <div class="hover-right" v-show="isShowRight">
              <div class="title">{{leftTitle}}</div>
              <div class="content">
                <div
                  class="item"
                  v-for="item in leftData"
                  :key="item.id"
                  @click="goToNav(item.id, item.categoryName)"
                ><span>{{item.categoryName}}</span></div>
              </div>
            </div>
          </div>
          <Menu mode="horizontal" :active-name="$route.path" @on-select="goTolink" class="left-nav">
            <template v-if="true">
              <MenuItem
                v-for="(item, index) in navList16988"
                :key="index"
                :name="item.url"
                :class="index == current ? 'nav-item ivu-menu-item ivu-menu-item-active ivu-menu-item-selected ' : 'nav-item ivu-menu-item '"
              >
                  {{item.title}}
              </MenuItem>
            </template>

            <template v-else>
              <MenuItem
                v-for="(item, index) in navList"
                :key="index"
                :name="item.url"
                :class="index == current ? 'nav-item ivu-menu-item ivu-menu-item-active ivu-menu-item-selected nav16988' : 'nav-item ivu-menu-item nav16988'"
              >
                  {{item.title}}
              </MenuItem>
            </template>
          </Menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIndexCategoryList } from '@/api/PersonalCenter'
import store from '@/vuex/store';
export default {
  name: 'SearchAndNav',
  data () {
    return {
      navHoverShow: false, // 右侧nav的显隐
      // 右侧nav的数据
      navList: [
        {
          title: '首页',
          url: '/'
        },
        {
          title: '商城',
          // title: '现货商城',
          url: '/Spotmall'
        },

        {
          title: '价格',
          url: '/price'
        },
        // {
        //   title: '行情',
        //   url: '/marketquotations'
        // },
        // {
        //   title: '资讯',
        //   url: '/Realtime'
        // },
        {
          title: '数据',
          url: '/Exportdata'
        },
        // {
        //   title: '企业',
        //   url: '/Company'
        // },
        // {
        //   title: '经纪人',
        //   url: '/broker'
        // },
        {
          title: '供求信息',
          url: '/supplyanddemand'
        },
        // {
        //   title: '研究报告',
        //   url: '/researchreport'
        // }
      ],
      navList16988: [
        {
          title: '首页',
          url: '/'
        },
        {
          title: '现货商城',
          url: '/Spotmall'
        },
        {
          title: '我要找货',
          url: '/findGoods'
        },
        // {
        //   title: '价格',
        //   url: '/price'
        // },
        // {
        //   title: '行情',
        //   url: '/marketquotations'
        // },
        // {
        //   title: '行业资讯',
        //   url: '/Realtime'
        // },
        {
          title: '实时行情',
          url: '/Quotes'
        },
        // 12.11隐藏数据入口
        // {
        //   title: '数据',
        //   url: '/Exportdata'
        // },
        {
          title: '城市合伙人',
          url: '/CityPartner'
        }
        // {
        //   title: '企业',
        //   url: '/Company'
        // },
        // {
        //   title: '经纪人',
        //   url: '/broker'
        // },
        // {
        //   title: '供求信息',
        //   url: '/supplyanddemand'
        // },
        // {
        //   title: '研究报告',
        //   url: '/researchreport'
        // }
      ],

      categoryList: { // 分类的全部数据
        level2: [
          { id: '0', categoryName: '' }
        ],
        level3: [
          { id: '0', categoryName: '' }
        ]
      },
      leftData: [],
      isShowRight: false,
      leftTitle: '产品类别',
      activename: '0',
      search: '',
      type: 'id2',
      current: -1, // 当前显示的item
      isEnd16988com: location.host.endsWith('16988.com')
    }
  },
  props: {
    // 强制显示右侧nav
    coerceNavShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    partCategoryList (){ // 分类的部分数据(在左侧显示)
      let level2 = [], level3 = []
      if (this.categoryList.level2.length > 4) {
        level2 = JSON.parse(JSON.stringify(this.categoryList.level2.slice(0, 4))) // 截取前4位后深拷
      } else {
        level2 = JSON.parse(JSON.stringify(this.categoryList.level2)) // 深拷
      }
      if (this.categoryList.level3.length > 6) {
        level3 = JSON.parse(JSON.stringify(this.categoryList.level3.slice(0,6))) // 截取前6位后深拷
      } else {
        level3 = JSON.parse(JSON.stringify(this.categoryList.level3)) // 深拷
      }
      return {'level2': level2, 'level3': level3}
    }
  },
  watch: {
    coerceNavShow: {
      immediate: true,
      handler (v) {
        if (v) this.navHoverShow = true
      }
    },
    '$route': {
      immediate: true,
      handler (v) {
        this.navList.some((i, index) => {
          // console.log(i.title,v.meta.belong,i.title == v.meta.belong);
          if (i.title == v.meta.belong) {
            this.current = index
          }
        })
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    // 点击跳转
    goTolink (url) {
      if (this.$route.path !== url) {
        this.$store.state.categoryCode = null
        this.$router.push(url)
      }
    },
    // 鼠标移入所有商品分类，展示。移出，不展示
    hoverNavAction (type) {
      // type 类型 : enter 进入,leave 离开
      if (this.coerceNavShow) return
      if (type === 'enter') {
        if (this.$route.name === 'Spotmall') return
        this.navHoverShow = true
      } else if (type === 'leave') {
        this.navHoverShow = false
      }
    },
    // 鼠标移入不同的分类，右侧展示不同内容
    showLeft (type) {
      this.leftTitle = type === 'level2' ? '产品类别' : '类目分类'
      this.leftData = this.categoryList[type] // 更改右侧显示的数据
      this.type = type === 'level2' ? 'id2' : 'id3'
      this.isShowRight = true
    },
    async init () { // 初始化，获取数据
      let res = await getIndexCategoryList()
      this.categoryList = res.data
    },
    // 搜索商品
    searchGoods () {
      if (this.$route.name === 'Spotmall') {
        this.$emit('search', this.search)
      } else {
        if (!this.search) return
        this.$router.push({name: 'Spotmall', query: {search: this.search}})
      }
    },
    // 点击所有商品分类的子项
    goToNav (id, name) {
      if (this.type === 'id2') {
        this.$router.push({name: 'Spotmall', query: {'id2': id, search: name}})
      } else {
        this.$router.push({name: 'Spotmall', query: {'id3': id, search: name}})
      }
    },
    // 点击logo到达首页
    clickLogo () {
      this.current = 0
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/_common.scss";
.container {
  height: 130px;
  width: 100%;

  .container-2 {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url("../../assets/bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .container-2 .box{
    height: 100%;
    width: 1200px;
    padding-top: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .container-2-top {
    height: 40px;
    display: flex;
    justify-content: space-between;
  }
  .container-2-bottom {
    height: 42px;
    display: flex;
  }
  .logo, .logo img {
    cursor: pointer;
    height: 40px;
    width: 420px;
  }
  .search {
    display: flex;
    border: 2px solid $mainColor;
    margin-left: 68px;
  }
  .search input {
    border: none;
    height: 100%;
    width: 420px;
    margin-left: 10px;
    caret-color:$mainColor;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    line-height: 18px;
  }
  .search input::placeholder {
    color: #CCCCCC;
  }
  .search input:focus {
    outline: none;
  }
  .search .button {
    width: 120px;
    height: 100%;
    cursor: pointer;
    background: $mainColor;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 21px;
  }
  .tip {
    margin-left: 20px;
    padding-left: 10px;
    width: 148px;
    height: 40px;
    display: flex;
    justify-content: start;
    align-items: center;
    background-image: url('/static/img/header/header_tipBG.png');
    background-size: 100% 100%;
  }
  .container-2-bottom .right-nav {
    width: 200px;
    height: 100%;
    background: $mainColor;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .right-nav img {
    width: 16px;
    height: 16px;
    margin-left: 20px;
  }
  .right-nav .right-nav-text {
    margin-left: 8px;
    cursor: default;
    font-size: 15px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: 700;
    color: #FFFFFF;
    line-height: 20px;
  }
  .left-nav{
    background: rgba(255,255,255,0);
    margin-left: 200px;
  }
  .left-nav,.left-nav .nav-item{
    display: flex;
    height: 100%;
    flex: 1;
    // padding: 0 30px;
    cursor: pointer;
  }

  .left-nav .nav-item{
    &.nav16988{
      flex: none !important;
      padding: 0 30px;
    }
  }


  .left-nav::after {
    display: none;
  }
  /deep/ .nav-item {
    /* -------------- */
    /* 取消iviewUI的menu组件的默认样式 */
    padding: 0;
    margin: 0;
    border: none !important;
    /* -------------- */
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 21px;
  }
  .container-2-bottom .left-nav /deep/ .ivu-menu-item:hover {
    font-weight: 400;
    color: #333333;
  }
  .left-nav /deep/ .ivu-menu-item-active {
    font-weight: 700 !important;
    color: $mainColor !important;
    user-select: none;
  }
  .right-nav {
    position: relative;
  }
  .nav-hover {
    position: absolute;
    top: 122px;
    display: flex;
    z-index: 999;
    .hover-left {
      width: 200px;
      height: 420px;
      display: flex;
      flex-direction: column;
      .quickSearchGoods {
        display: flex;
        align-items: center;
        height: 42px;
        width: 100%;
        background: #61A842;
        border-top-left-radius: 14px;
        border-top-right-radius: 14px;
        img {
          height: 16px;
          width: 16px;
          margin: 0 8px 0 20px;
        }
        .text {
          font-size: 16px;
          font-family: Microsoft YaHei-Bold, Microsoft YaHei;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 21px;
        }
      }
      .goodsCategory,.categoryClass {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        cursor: pointer;
        background-color: #FFFFFF;
        .navTitle {
          display: flex;
          align-items: center;
          width: 100%;
          padding: 16px 0;
          .icon {
            height: 16px;
            width: 16px;
            margin: 0 8px 0 20px;
          }
          .text {
            font-size: 14px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: bold;
            color: #1F1F1F;
            line-height: 18px;
            cursor: default;
          }
          .more {
            height: 16px;
            width: 8px;
            margin-left: 72px;
          }
        }
        .navContent {
          width: 100%;
          padding-left: 40px;
          display: grid;
          grid-template-columns: repeat(2,63px);
          row-gap: 10px;
          column-gap: 12px;
          background-color: #FFFFFF;
          .item {
            font-size: 12px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #1F1F1F;
            line-height: 16px;
            // ----超出显示省略号----
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            // ---------------------
            cursor: pointer;
          }
        }
      }
      .goodsCategory {
        height: 139px;
        .navTitle {
          height: 50px;
        }
        .navContent{
          height: 62px;
          grid-template-rows: repeat(2,16px);
        }
      }
      .categoryClass {
        height: 236px;
        .navTitle {
          height: 50px;
        }
        .navContent{
          height: 105px;
          grid-template-rows: repeat(3,16px);
        }
      }
    }
    .goodsCategory:hover,.categoryClass:hover {
      background-color: #FFFFFF;
      .item:hover {
        font-weight: 700;
        //color: $mainColor;
      }
    }
    .hover-right {
      height: 320px;
      width: 572px;
      background-color: #fff;
      box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.04);
      padding: 10px 20px;
      .title {
        padding-left: 20px;
        padding-bottom: 10px;
        height: 38px;
        display: flex;
        align-items: flex-end;
        font-size: 14px;
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        font-weight: 700;
        color: #333333;
        line-height: 18px;
        cursor: default;
        border-bottom: 1px solid #E5E5E5;
      }
      .content {
        height: 262px;
        // display: grid;
        // grid-template-columns: repeat(auto-fill,103px);
        // grid-template-rows: repeat(auto-fill,36px);
        overflow-y: auto;
        display: flex;
        align-content: flex-start;
        flex-wrap: wrap;
        .item {
          height: 36px;
          width: 103px;
          padding: 10px 20px;
          // ----超出显示省略号----
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          // ---------------------
          span {
            cursor: pointer;
          }
          &:hover {
            font-weight: 700;
            color: $mainColor;
          }
        }
      }
    }
    .item {
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 16px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/header/SearchAndNav.vue